/**
 * @generated SignedSource<<56dd349b84124dbc5c549a753fab6352>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RespondentFilter_questionnaire$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RespondentFilterUsingMetaGroups_questionnaire" | "RespondentFilterUsingMetaResults_questionnaire">;
  readonly " $fragmentType": "RespondentFilter_questionnaire";
};
export type RespondentFilter_questionnaire$key = {
  readonly " $data"?: RespondentFilter_questionnaire$data;
  readonly " $fragmentSpreads": FragmentRefs<"RespondentFilter_questionnaire">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RespondentFilter_questionnaire",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RespondentFilterUsingMetaGroups_questionnaire"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RespondentFilterUsingMetaResults_questionnaire"
    }
  ],
  "type": "QuestionnaireInterface",
  "abstractKey": "__isQuestionnaireInterface"
};

(node as any).hash = "5f6c284d7b873b059139224dda78efdc";

export default node;
